module.exports = __webpack_public_path__ + "img/approve-list24.270d6e19.png";